import { useEffect, useState } from "react";
import { Download, CheckCircle2, ArrowRight } from "lucide-react";
import { API_BASE, api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function Extension() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [version, setVersion] = useState("");

  useEffect(() => {
    api.get("/extension/version").then((r) => setVersion(r.data.version || "")).catch(() => {});
  }, []);

  return (
    <div className="space-y-8">
      <header className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground">Chrome Extension</div>
          <h1 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight">{t("extension.title")}</h1>
          <p className="mt-1.5 text-sm text-muted-foreground">{t("extension.subtitle")}</p>
        </div>
        {version && (
          <div className="text-xs text-muted-foreground">
            {t("extension.version")} {version}
          </div>
        )}
      </header>

      <Card>
        <CardContent className="p-6 grid md:grid-cols-3 gap-6">
          <div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <span className="h-5 w-5 rounded-full bg-secondary text-foreground grid place-items-center text-[10px] font-semibold">1</span>
              Baixar
            </div>
            <p className="mt-3 text-sm">{t("extension.step1")}</p>
            <a href={`${API_BASE}/extension/download`}>
              <Button className="mt-4 w-full" data-testid="btn-download-extension">
                <Download strokeWidth={1.5} className="h-4 w-4 mr-1.5" />
                {t("extension.download")}
              </Button>
            </a>
          </div>
          <div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <span className="h-5 w-5 rounded-full bg-secondary text-foreground grid place-items-center text-[10px] font-semibold">2</span>
              Instalar
            </div>
            <p className="mt-3 text-sm">{t("extension.step2")}</p>
            <div className="mt-4 border border-dashed border-border rounded-md p-3 text-xs text-muted-foreground font-mono">
              chrome://extensions
            </div>
          </div>
          <div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <span className="h-5 w-5 rounded-full bg-secondary text-foreground grid place-items-center text-[10px] font-semibold">3</span>
              Entrar
            </div>
            <p className="mt-3 text-sm">
              Abra o popup da extensão e faça login com o mesmo e-mail e senha usados aqui
              (<span className="font-mono">{user?.email}</span>).
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-muted-foreground">
              <CheckCircle2 strokeWidth={1.5} className="h-4 w-4 text-primary" />
              Sincroniza automaticamente com esta conta.
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6 space-y-3">
          <h3 className="text-sm font-semibold tracking-tight">Como salvar anúncios</h3>
          <ol className="text-sm text-muted-foreground space-y-2 list-decimal list-inside">
            <li>Abra o popup da extensão e clique em <strong className="text-foreground">Facebook Ad Library</strong>.</li>
            <li>Pesquise por qualquer palavra-chave ou anunciante.</li>
            <li>Em cada card de anúncio, clique no botão <strong className="text-foreground">SAVE</strong>.</li>
            <li>
              O anúncio completo (página, textos, imagens, vídeos e metadata) aparece
              automaticamente em <a href="/history" className="text-foreground hover-underline">Histórico <ArrowRight strokeWidth={1.5} className="inline h-3 w-3" /></a>.
            </li>
          </ol>
        </CardContent>
      </Card>
    </div>
  );
}
